import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const FormModal = ({ open, onOpenChange, title, description, children, onSubmit, submitText = "Save", loading = false, size = "md", className = "" }) => {
  const widths = { sm: "max-w-md", md: "max-w-lg", lg: "max-w-2xl", xl: "max-w-3xl" };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={`${widths[size]} ${className}`}>
        <DialogHeader>
          <DialogTitle className="font-display">{title}</DialogTitle>
          <DialogDescription>{description || "Fill in the fields below and click Save to continue."}</DialogDescription>
        </DialogHeader>
        <form onSubmit={(e) => { e.preventDefault(); onSubmit?.(); }} className="space-y-4">
          {children}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="form-cancel">Cancel</Button>
            <Button type="submit" disabled={loading} className="bg-navy-700 hover:bg-navy-800 text-white" data-testid="form-submit">
              {loading ? "Saving…" : submitText}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
